// extracted by mini-css-extract-plugin
export default {"form":"style_form__LPKNW","form_wrapper":"style_form_wrapper__YLSAt","disabled":"style_disabled__L2Nue","input":"style_input__WhWyi","bg":"style_bg__UP0ak"};